<ng-container [ngSwitch]="true">
  <ng-container *ngSwitchCase="currentPath.includes('prod-weekly')">
    <mat-form-field appearance="fill" class="prod-filter">
      <mat-label>Filter Foreman by Zone</mat-label>
      <mat-select
        [(value)]="selectedZone"
        (selectionChange)="selectZone($event)"
      >
        <mat-option [value]="0">All Zones</mat-option>
        <mat-option [value]="zone.zoneId" *ngFor="let zone of zones">{{
          zone.zoneName
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>

  <ng-container *ngSwitchCase="currentPath.includes('prod-monthly')">
    <mat-form-field appearance="fill" class="prod-filter">
      <mat-label>Filter Foreman by Zone</mat-label>
      <mat-select
        (selectionChange)="getForemanByZone($event.value)"
        [(value)]="selectedZone"
      >
        <mat-option [value]="0">All Zones</mat-option>
        <mat-option [value]="zone.zoneId" *ngFor="let zone of zones">{{
          zone.zoneName
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" class="prod-filter">
      <mat-label>Select Foreman</mat-label>
      <mat-select
        [(value)]="selectedForeman"
        (selectionChange)="selectForeman($event)"
      >
        <mat-option *ngFor="let foreman of foremanArray" [value]="foreman">{{
          foreman.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>
</ng-container>
